// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__22xJs","content":"LayoutSettings_content__2z4gU"};